export default __webpack_public_path__ + "static/stock_one_img-0869cbab5774d75fb1936794e39e8838.jpg";